var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.showData,
          expression: "showData"
        }
      ],
      staticClass: "day-stock-list print-font"
    },
    [
      _c(
        "div",
        { ref: "day-main-body", staticClass: "day-main-body print-font" },
        [
          _c(
            "div",
            {
              ref: "sortby-goods",
              staticClass: "sortby-goods printpage print-font"
            },
            [
              _c("div", { staticClass: "title text-center" }, [
                _vm._v("每日备货清单-按商品汇总")
              ]),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.goodsTableData }
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "index", label: "序号", width: "45" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "name", label: "商品名称" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "self_code", label: "商品编号", width: "95" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "ruigu_code",
                      label: "锐锢编码",
                      width: "75"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "total_amount", label: "数量", width: "45" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "storage_pos", label: "库位", width: "90" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "out_ware_day",
                      label: "要求发货日",
                      width: "100"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "total text-center" }, [
                _vm._v("\n        合计\n        "),
                _c("span", { staticClass: "totalnum" }, [
                  _vm._v(_vm._s(_vm.goodsTotalNum))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticStyle: { "margin-bottom": "15px" } }),
              _vm._v(" "),
              _vm.showPagePrint
                ? _c("div", { staticStyle: { "page-break-after": "always" } })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.showPagePrint
            ? _c("div", { staticStyle: { "page-break-after": "always" } })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { ref: "sortby-order", staticClass: "sortby-order print-font" },
            [
              !_vm.showPagePrint
                ? _c("div", { staticClass: "title text-center" }, [
                    _vm._v("\n        按订单分拣汇总\n      ")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.mainTableData, function(item) {
                return _c(
                  "div",
                  {
                    key: item.order_number,
                    staticClass: "order-content printpage"
                  },
                  [
                    _vm.showPagePrint
                      ? _c("div", { staticClass: "title text-center" }, [
                          _vm._v("\n          按订单分拣汇总\n        ")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "order-title bottom-gap" }, [
                      _c(
                        "span",
                        { staticClass: "order-title-item right-gap" },
                        [
                          _c("span", { staticClass: "order-title-label" }, [
                            _vm._v("主订单号")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "num" }, [
                            _vm._v(_vm._s(item.main_number))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "order-title-item right-gap" },
                        [
                          _c("span", { staticClass: "order-title-label" }, [
                            _vm._v("客户")
                          ]),
                          _vm._v(" "),
                          _vm.isFactory
                            ? _c("span", { staticClass: "phone" }, [
                                _c("span", { staticClass: "font-blod" }, [
                                  _vm._v(_vm._s(item.user_name))
                                ]),
                                _vm._v("/" + _vm._s(item.mobile))
                              ])
                            : _c("span", { staticClass: "phone" }, [
                                _vm._v(
                                  _vm._s(_vm._f("before3after4")(item.mobile))
                                )
                              ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "order-title-item" }, [
                        _c("span", { staticClass: "order-title-label" }, [
                          _vm._v("编号")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "code" }, [
                          item.serial_number
                            ? _c("span", { staticClass: "code" }, [
                                _vm._v(
                                  _vm._s(
                                    item.serial_number
                                      .split("-")
                                      .slice(3)
                                      .join("-")
                                  )
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isZhifaOrFactory && item.express
                            ? _c("span", { staticClass: "code" }, [
                                _vm._v("(" + _vm._s(item.express) + ")")
                              ])
                            : _vm._e()
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-table",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { data: item.orderTableData }
                      },
                      [
                        _c("el-table-column", {
                          attrs: { type: "index", label: "序号", width: "45" }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { prop: "name", label: "商品名称" }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "self_code",
                            label: "商品编号",
                            width: "95"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "ruigu_code",
                            label: "锐锢编码",
                            width: "75"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { prop: "amount", label: "数量", width: "45" }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "storage_pos",
                            label: "库位",
                            width: "90"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "order_number",
                            label: "子订单号",
                            width: "120"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "total text-center total" }, [
                      _vm._v("\n          合计\n          "),
                      _c("span", { staticClass: "totalnum" }, [
                        _vm._v(_vm._s(item.orderTotalNum))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticStyle: { "margin-bottom": "15px" } }),
                    _vm._v(" "),
                    _vm.showPagePrint
                      ? _c("div", {
                          staticStyle: { "page-break-after": "always" }
                        })
                      : _vm._e()
                  ],
                  1
                )
              }),
              _vm._v(" "),
              !_vm.showPagePrint
                ? _c("div", { staticClass: "orderTotal text-center total" }, [
                    _vm._v(
                      "\n        订单总合计:" +
                        _vm._s(_vm.orderAllNum) +
                        "\n      "
                    )
                  ])
                : _vm._e()
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "day-btns" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.myPrint }
            },
            [_vm._v("打印")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.pagePrint }
            },
            [_vm._v("分页打印")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "date" },
        [
          _c("span", [_vm._v("要求发货日")]),
          _vm._v(" "),
          _c("el-date-picker", {
            attrs: {
              align: "right",
              type: "date",
              format: "yyyy-MM-dd",
              "value-format": "yyyy-MM-dd",
              placeholder: "选择日期"
            },
            on: { change: _vm.changeDate },
            model: {
              value: _vm.outWareDate,
              callback: function($$v) {
                _vm.outWareDate = $$v
              },
              expression: "outWareDate"
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5adb18aa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5adb18aa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/day-stock-list.vue
// module id = null
// module chunks = 